import { createExistingOrderMutationOrderFragments, nextErrorFragmentWithErrorMessage } from 'next-common';

export const createExistingOrderMutation = `
  mutation createExistingOrder(
    $id: String!
    $input: OrderInput!
    $removeAccessories: [VehicleRemoveAccessoryInput!]
    $removePcodes: [PCodesInput!]
  ) {
    createExistingOrder(
      id: $id
      OrderInput: $input
      removeAccessories: $removeAccessories
      removePcodes: $removePcodes
    ) {
      ...order
      ...nextError
    }
  }
  ${nextErrorFragmentWithErrorMessage}
  ${createExistingOrderMutationOrderFragments}
`;

export const createExistingOrderWithVehicleMutation = `
  mutation createExistingOrderWithVehicle(
    $id: String!
    $input: OrderInput!
    $vehicles: [VehicleInput!]
    $options: [VehicleOptionInput!]
    $priceConjunctionList: [PriceConjunctionInput!]
    $removeAccessories: [VehicleRemoveAccessoryInput!]
    $removePcodes: [PCodesInput!]
  ) {
    createExistingOrderWithVehicle(
      id: $id
      OrderInput: $input
      vehicles: $vehicles
      options: $options
      priceConjunctionList: $priceConjunctionList
      removeAccessories: $removeAccessories
      removePcodes: $removePcodes
    ) {
      ...order
      ...nextError
    }
  }
  ${nextErrorFragmentWithErrorMessage}
  ${createExistingOrderMutationOrderFragments}
`;

export const createExistingOrderWithVehicleAndVehicleEquipmentMutation = `
  mutation createExistingOrderWithVehicleAndVehicleEquipment(
    $id: String!
    $input: OrderInput!
    $vehicles: [VehicleInput!]
    $options: [VehicleOptionInput!]
    $equipments: [VehicleEquipmentInput!]
    $priceConjunctionList: [PriceConjunctionInput!]
    $removeAccessories: [VehicleRemoveAccessoryInput!]
    $removePcodes: [PCodesInput!]
  ) {
    createExistingOrderWithVehicleAndVehicleEquipment(
      id: $id
      OrderInput: $input
      vehicles: $vehicles
      options: $options
      equipments: $equipments
      priceConjunctionList: $priceConjunctionList
      removeAccessories: $removeAccessories
      removePcodes: $removePcodes
    ) {
      ...order
      ...nextError
    }
  }
  ${nextErrorFragmentWithErrorMessage}
  ${createExistingOrderMutationOrderFragments}
`;

export const updateVehicleOptionsOnOrderMutation = `
mutation updateVehicleOptionsOnOrder($orderId: ID!) {
  updateVehicleOptionsOnOrder(orderId: $orderId) {
    ...order
    ...nextError
  }
}
${nextErrorFragmentWithErrorMessage}
${createExistingOrderMutationOrderFragments}  
`;
